<svg:g xmlns:svg="http://www.w3.org/2000/svg" chart-axis [config]="axisConfig"></svg:g>

<!-- Bubbles: translucent fill + solid rim so overlapping points stay readable. -->
<svg:g xmlns:svg="http://www.w3.org/2000/svg" class="points">
    <svg:circle *ngFor="let p of points" class="point"
                [attr.cx]="p.cx" [attr.cy]="p.cy" [attr.r]="p.r"
                [attr.fill]="p.fill" fill-opacity="0.45"
                [attr.stroke]="p.fill" stroke-width="1.5"
                container="body" ngbPopover="{{p.text}}" triggers="mouseenter:mouseleave"
                popoverTitle="{{p.label}}"></svg:circle>
</svg:g>
